export default "/fonts/hotelspace.ttf?43e84a5141787de79e7a75fc97e4c75b";